export const PLATFORMS = ['linkedin', 'instagram', 'telegram', 'tiktok', 'facebook', 'x'];

export const PLATFORM_LABELS = {
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  telegram: 'Telegram',
  tiktok: 'TikTok',
  facebook: 'Facebook',
  x: 'X',
};

export const PLATFORM_COLORS = {
  linkedin: '#0a66c2',
  instagram: '#e1306c',
  telegram: '#229ed9',
  tiktok: '#69c9d0',
  facebook: '#1877f2',
  x: '#000000',
};

export const FORMAT_OPTIONS = [
  { value: 'text_post', label: 'Text post' },
  { value: 'image_post', label: 'Image post' },
  { value: 'carousel', label: 'Carousel' },
  { value: 'video', label: 'Video' },
  { value: 'story', label: 'Story' },
  { value: 'reel', label: 'Reel' },
];

export const GOAL_OPTIONS = [
  { value: 'visibility', label: 'Visibility' },
  { value: 'leads', label: 'Leads' },
  { value: 'authority', label: 'Authority' },
  { value: 'community', label: 'Community' },
  { value: 'sales', label: 'Sales' },
  { value: 'education', label: 'Education' },
];

export const TONE_OPTIONS = [
  { value: 'professional', label: 'Professional' },
  { value: 'playful', label: 'Playful' },
  { value: 'friendly', label: 'Friendly' },
  { value: 'bold', label: 'Bold' },
  { value: 'authoritative', label: 'Authoritative' },
  { value: 'custom', label: 'Custom' },
];

export const VISUAL_STYLE_OPTIONS = [
  { value: 'premium_dark', label: 'Premium dark' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'vibrant', label: 'Vibrant' },
  { value: 'muted', label: 'Muted' },
  { value: 'luxe', label: 'Luxe' },
  { value: 'playful', label: 'Playful' },
  { value: 'custom', label: 'Custom' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'uk', label: 'Українська' },
  { value: 'ru', label: 'Русский' },
  { value: 'es', label: 'Español' },
  { value: 'de', label: 'Deutsch' },
  { value: 'fr', label: 'Français' },
];
